import React from 'react'
import ListaDesplegable from './ListaDesplegable'
import {aplicarFormatoMoneda} from '../../utils'

const ListaDesplegableConResultado = ({
  titulo,
  estilosTitulo = '',
  estilosInput,
  opciones = [],
  valor,
  funcion,
  totalCalculado,
  descripcion,
  deshabilitarTab = false,
  colorTextoOpciones = '',
  opcionPorDefecto,
}) => {
  return (
    <div
      className={'w-full flex flex-wrap justify-start items-center ml-2 my-2'}
    >
      <>
        <span
          className={`w-6/12 text-cendiatra-verde-3 font-bold ${estilosTitulo}`}
        >
          {titulo}
        </span>
        <ListaDesplegable
          estilosContenedor={'w-3/12 flex items-center'}
          estilosLista={estilosInput}
          titulo={''}
          opciones={opciones}
          valor={valor}
          onChange={funcion}
          deshabilitado={deshabilitarTab}
          colorTextoOpciones={colorTextoOpciones}
          tabIndex={'-1'}
          nombrePropiedadPorDefecto={opcionPorDefecto}
        />
        <span className="w-2/12 text-cendiatra-verde-3 font-bold text-center text-lg">
          {totalCalculado ? aplicarFormatoMoneda(totalCalculado) : '$0'}
        </span>
        <span className="w-full text-cendiatra-gris-1 font-bold">
          {descripcion}
        </span>
      </>
    </div>
  )
}

export default ListaDesplegableConResultado
